module.exports = __webpack_public_path__ + "img/c02_unitcatapulttrireme_Normal_ua.14039b73.webp";